<template>
    <div class="background">
        <div class="input">
            <van-field v-model="phone" type="number" placeholder="请输入手机号" input-align="center" class="inputField"/>
            <van-row>
                <van-col span="12">
                    <van-button round size="small" @click="confirmRecharge" class="buyButton">点击去购买</van-button>
                </van-col>
                <van-col span="12">
                    <van-button round size="small" :url="'https://mas2.shengdianhuadg.com/frontend_service/common?appid=3&funid=193&isapp=1&channel=87354'" class="buyButton">激活锦鲤卡</van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import jdPayAPI from '@/api/jdPay';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                    pid: this.$route.query.pid,
                },
                phone: '',
            }
        },
        methods: {
            confirmRecharge() {
                if (!this.$myUtil.mobile(this.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                this.$toast("正在跳转支付...");
                jdPayAPI.jingli(this.query.traderId, this.phone, this.query.pid).then((result) => {
                    window.location.href = result.data;
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("jingliJdPay/index", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoSsAoR.jpg');
        background-size: 100% 100%;
        height: 70rem;
        padding-top: 31rem;
        text-align: center;
    }

    .input {
        margin: 0 auto;
        width: 85%;
    }

    .inputField {
        height: 4rem;
        border-radius: 2rem;
        font-size: 1.8rem;
    }

    .buyButton {
        margin-top: 1.5rem;
        height: 4rem;
        width: 11.5rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NoSyGG1.png");
        background-size: 100% 100%;
        font-size: 2rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
